var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhenRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z",
    fill: "#FEF2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5265 23.8067C21.6986 23.8858 21.8925 23.9038 22.0762 23.8579C22.26 23.8121 22.4226 23.7049 22.5373 23.5542L22.8332 23.1667C22.9884 22.9598 23.1897 22.7917 23.4211 22.676C23.6526 22.5603 23.9078 22.5001 24.1665 22.5001H26.6665C27.1085 22.5001 27.5325 22.6757 27.845 22.9882C28.1576 23.3008 28.3332 23.7247 28.3332 24.1667V26.6667C28.3332 27.1088 28.1576 27.5327 27.845 27.8453C27.5325 28.1578 27.1085 28.3334 26.6665 28.3334C22.6883 28.3334 18.8729 26.7531 16.0599 23.94C13.2469 21.127 11.6665 17.3117 11.6665 13.3334C11.6665 12.8914 11.8421 12.4675 12.1547 12.1549C12.4672 11.8423 12.8911 11.6667 13.3332 11.6667H15.8332C16.2752 11.6667 16.6991 11.8423 17.0117 12.1549C17.3242 12.4675 17.4998 12.8914 17.4998 13.3334V15.8334C17.4998 16.0922 17.4396 16.3473 17.3239 16.5788C17.2082 16.8102 17.0402 17.0115 16.8332 17.1667L16.4432 17.4592C16.2902 17.5761 16.1824 17.7422 16.138 17.9295C16.0936 18.1168 16.1155 18.3137 16.1998 18.4867C17.3387 20.8 19.2119 22.6707 21.5265 23.8067Z",
    stroke: "#E7000B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhenRequestIcon);
export default __webpack_public_path__ + "static/media/when_request_icon.8f8171aaaaa41a55690ae2deb6274c6a.svg";
export { ForwardRef as ReactComponent };